import type { ICognitoStorage } from 'amazon-cognito-identity-js';
import { Amplify } from '@aws-amplify/core';

export default class Aws {
  static configureAmplify({ authStorage }: { authStorage: ICognitoStorage }) {
    Amplify.configure({
      Auth: {
        identityPoolId: 'us-west-2:479d5c88-369e-4ebc-8782-f0acc6463491',
        region: 'us-west-2',
        userPoolId: 'us-west-2_fD8ohKI0Z',
        userPoolWebClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        storage: authStorage,
      },
      oauth: {
        domain: 'auth.geopard.tech',
        scope: [
          'phone',
          'email',
          'profile',
          'openid',
          'aws.cognito.signin.user.admin',
        ],
        redirectSignIn: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN_URL,
        redirectSignOut: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT_URL,
        responseType: 'code',
      },
      aws_appsync_graphqlEndpoint: import.meta.env.VITE_AWS_GRAPHQL_ENDPOINT,
      aws_appsync_region: 'us-west-2',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_apiKey: import.meta.env.VITE_AWS_GRAPHQL_KEY,
      Analytics: { disabled: true },
    });
  }
}
